import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ImportQuestion } from '../../../models/classic-import.model';
import { ProjectMemberDTO } from '../../../models/project-member.model';
import { PersonSelectComponent } from '../../../components/person-select/person-select.component';
import { SuccessBannerComponent } from '../../../components/success-banner/success-banner.component';
import { reviewerOptionsFromMembers } from '../../../shared/project-member-options';

/**
 * Schritt „Nutzer“ des Classic-Imports: je Frage USER_MAPPING eine Zeile mit Personenauswahl.
 * Das BE liefert Nummer, Name, Art und Anzahl nur im Fragetext; deshalb zeigt die Zeile den Text.
 */
@Component({
  selector: 'app-classic-import-users',
  imports: [FormsModule, TranslatePipe, PersonSelectComponent, SuccessBannerComponent],
  templateUrl: './classic-import-users.component.html',
  styleUrl: './classic-import-users.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassicImportUsersComponent {
  readonly questions = input.required<ImportQuestion[]>();
  readonly members = input<ProjectMemberDTO[]>([]);
  readonly answers = input<Record<string, string>>({});
  readonly loading = input(false);
  readonly loadFailed = input(false);
  readonly answersChange = output<Record<string, string>>();
  readonly retry = output<void>();

  readonly userQuestions = computed(() => this.questions().filter((q) => q.type === 'USER_MAPPING'));
  readonly options = computed(() => reviewerOptionsFromMembers(this.members()));

  readonly allMapped = computed(() => {
    const ids = new Set(this.options().map((o) => o.id));
    const answers = this.answers();
    const rows = this.userQuestions();
    return rows.length > 0 && rows.every((q) => ids.has(answers[q.id]));
  });

  choose(questionId: string, personId: string | null): void {
    const next = { ...this.answers() };
    if (personId) next[questionId] = personId;
    else delete next[questionId];
    this.answersChange.emit(next);
  }
}
